<template>
  <v-sheet
    rounded
    @click="$emit('click', $event)"
    :class="[
      'check-card cursor-pointer relative audience-template-card px-8 py-6 fill-height d-flex flex-column align-start',
      active ? 'check-card--active' : '',
    ]"
  >
    <div :class="['audience-template-card__border', template.type.color]" />
    <div class="body-1 font-weight-bold mb-2" v-text="template.name" />
    <div class="body-1" v-text="template.description" />
    <div class="mt-auto pt-6 ml-n1">
      <ui-temperature-chip :template-type="template.type" />
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: "AudienceTemplateCard",
  props: {
    template: Object,
    active: Boolean,
  },
}
</script>

<style scoped>
.audience-template-card {
  overflow: hidden;
}

.audience-template-card__border {
  position: absolute;
  width: 8px;
  left: -2px;
  top: -2px;
  bottom: -2px;
  background-color: currentColor;
}
</style>
